// Блок «Рекомендуемые» на карте /tutors (02.11.2026). Без слов о качестве:
// это активные преподаватели, которые работают с Yolutap, а не «лучшие».
import type { SiteLang } from "@/components/site/SiteChrome";

export const FEATURED_COPY: Record<SiteLang, { title: string; badge: string; infoBtn: string; info: string }> = {
  az: {
    title: "Tövsiyə olunanlar",
    badge: "Tövsiyə olunur",
    infoBtn: "Tövsiyə olunanlar haqqında",
    info: "Yolutap-la əməkdaşlıq edən fəal müəllimlər",
  },
  ru: {
    title: "Рекомендуемые",
    badge: "Рекомендуется",
    infoBtn: "О рекомендуемых",
    info: "Активные преподаватели, сотрудничающие с Yolutap",
  },
  en: {
    title: "Featured",
    badge: "Featured",
    infoBtn: "About featured",
    info: "Active teachers who work with Yolutap",
  },
};
